module.exports = __webpack_public_path__ + "media/images/faces/male/29-157cb98ea553451d3036fbaff6890900.jpg";